const STORAGE_KEY = 'interactive-tutorial';

export const saveTutorialState = (state: { step: number; finished: boolean }) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const loadTutorialState = (): {
  step: number;
  finished: boolean;
} | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if ('step' in parsed && 'finished' in parsed) {
      return {
        step: 1,
        finished: parsed.finished,
        // ...parsed,
      };
    }
  } catch {
    //
  }
  return null;
};
